import { Chip, type ChipProps } from '@mui/material'
import { STATUS_TONES, type StatusTone } from '../themes/statusColors'

export type ToneChipProps = Omit<ChipProps, 'color' | 'variant'> & { tone: StatusTone }

/**
 * A status pill colored by TONE (UI-STYLE-GUIDE §3), never by MUI palette
 * color. Screens used to reach for `color="success" variant="filled"` (a
 * saturated green "Active" on every client row), `color="warning"
 * variant="outlined"` (an orange "No Recent Data" on every pet row) and
 * `color="primary"` count chips — each one spending loud color on a state
 * that needs no action. Map the domain state to a tone, render this.
 */
export const ToneChip = ({ tone, sx, ...rest }: ToneChipProps) => {
  const t = STATUS_TONES[tone]
  return (
    <Chip
      size="small"
      data-tone={tone}
      {...rest}
      sx={{
        height: 22,
        borderRadius: '999px',
        border: '1px solid',
        borderColor: t.borderColor,
        bgcolor: t.bgcolor,
        color: t.color,
        fontSize: 12,
        fontWeight: 600,
        '& .MuiChip-label': { px: 1 },
        ...sx,
      }}
    />
  )
}

export default ToneChip
